import { render, staticRenderFns } from "./WashDisinfect.vue?vue&type=template&id=47ae8476"
import script from "./WashDisinfect.vue?vue&type=script&lang=js"
export * from "./WashDisinfect.vue?vue&type=script&lang=js"
import style0 from "./WashDisinfect.vue?vue&type=style&index=0&id=47ae8476&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports